import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const VerifyEmailPage = lazy(() => import('../pages/verify-email/page'));
const ForgotPasswordPage = lazy(() => import('../pages/forgot-password/page'));
const DashboardLayout = lazy(() => import('../pages/dashboard/layout'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const WalletPage = lazy(() => import('../pages/dashboard/wallet/page'));
const CardsPage = lazy(() => import('../pages/dashboard/cards/page'));
const TransactionsPage = lazy(() => import('../pages/dashboard/transactions/page'));
const SettingsPage = lazy(() => import('../pages/dashboard/settings/page'));

const PageLoader = () => (
  <div className="min-h-screen bg-slate-950 flex items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
      <p className="text-slate-400 font-medium text-sm">Loading...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<PageLoader />}><HomePage /></Suspense>,
  },
  {
    path: '/login',
    element: <Suspense fallback={<PageLoader />}><LoginPage /></Suspense>,
  },
  {
    path: '/signup',
    element: <Suspense fallback={<PageLoader />}><SignupPage /></Suspense>,
  },
  {
    path: '/verify-email',
    element: <Suspense fallback={<PageLoader />}><VerifyEmailPage /></Suspense>,
  },
  {
    path: '/forgot-password',
    element: <Suspense fallback={<PageLoader />}><ForgotPasswordPage /></Suspense>,
  },
  {
    path: '/dashboard',
    element: <Suspense fallback={<PageLoader />}><DashboardLayout /></Suspense>,
    children: [
      {
        index: true,
        element: <Suspense fallback={<PageLoader />}><DashboardPage /></Suspense>,
      },
      {
        path: 'wallet',
        element: <Suspense fallback={<PageLoader />}><WalletPage /></Suspense>,
      },
      {
        path: 'cards',
        element: <Suspense fallback={<PageLoader />}><CardsPage /></Suspense>,
      },
      {
        path: 'transactions',
        element: <Suspense fallback={<PageLoader />}><TransactionsPage /></Suspense>,
      },
      {
        path: 'settings',
        element: <Suspense fallback={<PageLoader />}><SettingsPage /></Suspense>,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
